import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
  Box,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useState } from "react";
import { useNotification } from "../../hooks/useNotification";
import useStyles from "../../themes/style.js";
import LeftPrfileImage from "../../images/profile/profileLeftImg.png";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const ChangePassword = ({onUpdate}) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const handleNotificationCall = useNotification();
  const [passwordHidden, setPasswordHidden] = useState({
    showOldPassword: false,
    showPassword: false,
    showConfirmPassword: false,
  });
  const [loader, setLoader] = useState(false);

  const handleClickOldPassword = () => {
    setPasswordHidden({
      ...passwordHidden,
      showOldPassword: !passwordHidden.showOldPassword,
    });
  };

  const handleClickShowPassword = () => {
    setPasswordHidden({
      ...passwordHidden,
      showPassword: !passwordHidden.showPassword,
    });
  };

  const handleClickConfirmPassword = () => {
    setPasswordHidden({
      ...passwordHidden,
      showConfirmPassword: !passwordHidden.confirm,
    });
  };

  const changeSchema = Yup.object().shape({
    old: Yup.string()
      .required("Old Password is required")
      .min(8, "Old Password must be at least 8 characters"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),
    confirm: Yup.string()
      .required("Confirm Password is required")
      .min(8, "Confirm Password must be at least 8 characters"),
  });

  const {
    register: changePassword,
    reset,
    formState: { errors: changeErrors, isSubmitting: changeIsSubmitting },
    handleSubmit: changeSubmit,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(changeSchema),
  });

  async function handleChangePassword(values) {
    if (values.password !== values.confirm) {
      handleNotificationCall("error", "Password is mismatch");
      return;
    }
    setLoader(true);
    try {
      var decode = jwtDecode(token);
      var url =
        decode.role === "SUPERADMIN"
          ? `${process.env.REACT_APP_SERVER}superadmin/changeMyPassword`
          : `${process.env.REACT_APP_SERVER}auth/changeMyPassword`;

      const response = await axios({
        method: "post",
        url: url,
        data: {
          newPassword: values.password,
          oldPassword: values.old,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        onUpdate();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  return (
    <Card className={classes.root}>
      <form onSubmit={changeSubmit(handleChangePassword)}>
        <CardContent className={classes.root}>
          <Grid container direction="row" alignItems="flex-start" spacing={2}>
            <Grid item xs={12} md={6}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">Change Password</Typography>
                </Grid>
                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="old">
                    Old Password
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      type={
                        passwordHidden.showOldPassword ? "text" : "password"
                      }
                      placeholder="Enter Password"
                      InputProps={{
                        disableUnderline: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickOldPassword}
                            >
                              {passwordHidden.showOldPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...changePassword("old")}
                      error={changeErrors.old ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {changeErrors.old?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="password">
                    Password
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      type={passwordHidden.showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      InputProps={{
                        disableUnderline: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                            >
                              {passwordHidden.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...changePassword("password")}
                      error={changeErrors.password ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {changeErrors.password?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="confirm">
                    Confirm Password
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      classes={{ root: classes.customTextField }}
                      type={
                        passwordHidden.showConfirmPassword ? "text" : "password"
                      }
                      placeholder="Enter Confirm Password"
                      InputProps={{
                        disableUnderline: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickConfirmPassword}
                            >
                              {passwordHidden.showConfirmPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...changePassword("confirm")}
                      error={changeErrors.confirm ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {changeErrors.confirm?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" gridGap={8}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="submit"
                      disabled={changeIsSubmitting}
                    >
                      Update
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={reset}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
                <img src={LeftPrfileImage} alt="Profile Left Image"  className="img-fluid d-lg-block d-none" width="100%" />
            </Grid>
          </Grid>
        </CardContent>
      </form>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Card>
  );
};

export default ChangePassword;
